export default __webpack_public_path__ + "static/media/Sharja-department-of-economic-development.9d3e907f.png";